import { LEVELS } from '../Const';

export const BHMapping = {
  netCashInflowsoutflowsFromOperatingActivities: 'cfa18',
  operatingProfitlossBeforeChangesInWc: 'cfa9',
  netProfitlossBeforeTax: 'cfa1',
  depreciationAndAmortisation: 'cfa2',
  amortisationOfGoodwill: 'cfa103',
  provisions: 'cfa3',
  unrealisedForeignExchange: 'cfa4',
  profitlossFromInvesting: 'cfa6',
  interestExpense: 'cfa7',
  interestIncomeAndDividend: 'cfa8',
  otherAdjustments: 'cfa104',
  increasedecreaseInReceivables: 'cfa10',
  grossWrittenPremiumReceivables: 'cfi89',
  reinsuranceAssumedReceivables: 'cfi90',
  reinsuranceCededReceivables: 'cfi91',
  otherReceivablesFromInsuranceActivities: 'cfi92',
  intercompanyReceivablespayables: 'cfi93',
  increasedecreaseInInventories: 'cfa11',
  increasedecreaseInPayablesNotIncludingInterestPaidAndTaxExpensePaid: 'cfa12',
  grossWrittenPremiumPayables: 'cfi94',
  reinsuranceAssumedPayables: 'cfi95',
  reinsuranceCededPayables: 'cfi96',
  otherPayablesFromInsuranceActivities: 'cfi97',
  payablesToEmployees: 'cfi98',
  increasedecreaseInPrepaidExpenese: 'cfa13',
  increasedecreaseInTradingSecurities: 'cfa105',
  interestPaid: 'cfa14',
  businessIncomeTaxPaid: 'cfa15',
  otherReceiptsFromOperatingActivities: 'cfa16',
  otherPaymentsOnOperatingActivities: 'cfa17',
  netCashInflowsoutflowsFromInvestingActivities: 'cfa26',
  purchasesOfFixedAssetsAndOtherLongtermAssets: 'cfa19',
  proceedsFromDisposalOfFixedAssets: 'cfa20',
  loansGrantedPurchasesOfDebtInstrument: 'cfa21',
  collectionOfLoansProceedsFromSalesOfDebtsInstruments: 'cfa22',
  investmentInOtherEntities: 'cfa23',
  proceedsFromDivestmentInOtherEntities: 'cfa24',
  dividendsAndInteresteReceived: 'cfa25',
  netCashInflowsoutflowsFromFinancingActivities: 'cfa34',
  proceedsFromIssueOfShares: 'cfa27',
  paymentsForShareReturensAndRepurchases: 'cfa28',
  proceedsFromLoans: 'cfa29',
  repaymentOfLoans: 'cfa30',
  financeLeasePrincipalPayments: 'cfa31',
  dividendPaid: 'cfa32',
  netIncreaseInCashAndCashEquivalents: 'cfa35',
  cashAndCashEquivalentsAtTheBeginningOfThePeriod: 'cfa36',
  effectOfForeignExchangeDifferences: 'cfa37',
  cashAndCashEquivalentsAtTheEndOfThePeriod: 'cfa38',
};

export const CFBHRows = Object.keys(BHMapping).map(key => {
  const mappingValue = BHMapping[key];
  const defaultItem = {
    id: mappingValue,
    i18nKey: `cashFlowStatementInsurance.${key}`,
    level: LEVELS.PARENT,
  };
  if (
    [
      BHMapping.netIncreaseInCashAndCashEquivalents,
      BHMapping.cashAndCashEquivalentsAtTheBeginningOfThePeriod,
      BHMapping.effectOfForeignExchangeDifferences,
      BHMapping.cashAndCashEquivalentsAtTheEndOfThePeriod,
    ].includes(mappingValue)
  ) {
    return defaultItem;
  }

  if (
    mappingValue === BHMapping.netCashInflowsoutflowsFromOperatingActivities
  ) {
    return {
      ...defaultItem,
      children: [
        BHMapping.operatingProfitlossBeforeChangesInWc,
        BHMapping.increasedecreaseInReceivables,
        BHMapping.increasedecreaseInInventories,
        BHMapping.increasedecreaseInPayablesNotIncludingInterestPaidAndTaxExpensePaid,
        BHMapping.increasedecreaseInPrepaidExpenese,
        BHMapping.increasedecreaseInTradingSecurities,
        BHMapping.interestPaid,
        BHMapping.businessIncomeTaxPaid,
        BHMapping.otherReceiptsFromOperatingActivities,
        BHMapping.otherPaymentsOnOperatingActivities,
      ],
    };
  }

  if (mappingValue === BHMapping.operatingProfitlossBeforeChangesInWc) {
    return {
      ...defaultItem,
      level: LEVELS.CHILD,
      children: [
        BHMapping.netProfitlossBeforeTax,
        BHMapping.depreciationAndAmortisation,
        BHMapping.amortisationOfGoodwill,
        BHMapping.provisions,
        BHMapping.unrealisedForeignExchange,
        BHMapping.profitlossFromInvesting,
        BHMapping.interestExpense,
        BHMapping.interestIncomeAndDividend,
        BHMapping.otherAdjustments,
      ],
    };
  }

  if (mappingValue === BHMapping.increasedecreaseInReceivables) {
    return {
      ...defaultItem,
      level: LEVELS.CHILD,
      children: [
        BHMapping.grossWrittenPremiumReceivables,
        BHMapping.reinsuranceAssumedReceivables,
        BHMapping.reinsuranceCededReceivables,
        BHMapping.otherReceivablesFromInsuranceActivities,
        BHMapping.intercompanyReceivablespayables,
      ],
    };
  }

  if (
    mappingValue ===
    BHMapping.increasedecreaseInPayablesNotIncludingInterestPaidAndTaxExpensePaid
  ) {
    return {
      ...defaultItem,
      level: LEVELS.CHILD,
      children: [
        BHMapping.grossWrittenPremiumPayables,
        BHMapping.reinsuranceAssumedPayables,
        BHMapping.reinsuranceCededPayables,
        BHMapping.otherPayablesFromInsuranceActivities,
        BHMapping.payablesToEmployees,
      ],
    };
  }

  if (
    mappingValue === BHMapping.netCashInflowsoutflowsFromInvestingActivities
  ) {
    return {
      ...defaultItem,
      children: [
        BHMapping.purchasesOfFixedAssetsAndOtherLongtermAssets,
        BHMapping.proceedsFromDisposalOfFixedAssets,
        BHMapping.loansGrantedPurchasesOfDebtInstrument,
        BHMapping.collectionOfLoansProceedsFromSalesOfDebtsInstruments,
        BHMapping.investmentInOtherEntities,
        BHMapping.proceedsFromDivestmentInOtherEntities,
        BHMapping.dividendsAndInteresteReceived,
      ],
    };
  }

  if (
    mappingValue === BHMapping.netCashInflowsoutflowsFromFinancingActivities
  ) {
    return {
      ...defaultItem,
      children: [
        BHMapping.proceedsFromIssueOfShares,
        BHMapping.paymentsForShareReturensAndRepurchases,
        BHMapping.proceedsFromLoans,
        BHMapping.repaymentOfLoans,
        BHMapping.financeLeasePrincipalPayments,
        BHMapping.dividendPaid,
      ],
    };
  }

  if (
    [
      BHMapping.grossWrittenPremiumPayables,
      BHMapping.reinsuranceAssumedPayables,
      BHMapping.otherPayablesFromInsuranceActivities,
      BHMapping.payablesToEmployees,
      BHMapping.grossWrittenPremiumReceivables,
      BHMapping.reinsuranceAssumedReceivables,
      BHMapping.reinsuranceCededPayables,
      BHMapping.otherReceivablesFromInsuranceActivities,
      BHMapping.intercompanyReceivablespayables,
      BHMapping.netProfitlossBeforeTax,
      BHMapping.depreciationAndAmortisation,
      BHMapping.amortisationOfGoodwill,
      BHMapping.provisions,
      BHMapping.unrealisedForeignExchange,
      BHMapping.profitlossFromInvesting,
      BHMapping.interestExpense,
      BHMapping.interestIncomeAndDividend,
      BHMapping.otherAdjustments,
      BHMapping.reinsuranceCededReceivables,
    ].includes(mappingValue)
  ) {
    return {
      ...defaultItem,
      level: LEVELS.THREE,
    };
  }

  return {
    ...defaultItem,
    level: LEVELS.CHILD,
  };
});
